<template>
  <u-animate-container
    id="nav"
    :class="[isHover ? 'hover' : '']"
    @mouseenter.native="hoverOn"
    @mouseleave.native="hoverOff"
  >
    <u-animate
      name="zoomIn"
      delay="0s"
      duration="1s"
      :iteration="1"
      :offset="0"
      animateClass="animated"
      :begin="false"
      class="container"
    >
      <router-link
        to="/product/0"
        :title="$t('menu.product')"
        @mouseenter.native="changeHoverIndex(1)"
        >{{ $t("menu.product") }}</router-link
      >
      <p :title="$t('menu.solution')" @mouseenter="changeHoverIndex(2)">
        {{ $t("menu.solution") }}
      </p>
      <router-link to="/index" title="sailuk首页">
        <img src="@/assets/images/logo_black.png" alt="sailuk" />
      </router-link>
      <router-link
        to="/about"
        :title="$t('menu.about')"
        @mouseenter.native="changeHoverIndex(3)"
        >{{ $t("menu.about") }}</router-link
      >
      <router-link
        to="/contact"
        :title="$t('menu.contact')"
        @mouseenter.native="changeHoverIndex(0)"
        >{{ $t("menu.contact") }}</router-link
      >
      <div class="search">
        <input
          v-model="keyword"
          class="active"
          type="text"
          :placeholder="$t('menu.search')"
        />
        <img
          class="search-icon"
          src="@/assets/images/icon_search_black.png"
          alt="站内搜索"
          @click="handleSearch"
        />
      </div>
    </u-animate>
    <div class="menu" :class="[menuIndex != 0 ? 'on' : '']">
      <div class="left">
        <template v-if="menuIndex === 1">
          <router-link
            :to="'/product/' + i['pcId']"
            v-for="i in productList.categoryList"
            :key="i['name']"
            >{{ i["name"] }}</router-link
          >
        </template>
        <template v-if="menuIndex === 2">
          <router-link
            :to="'/solution/' + i['category']"
            v-for="i in solutionList.solutionList"
            :key="i['name']"
            replace
            >{{ i["name"] }}</router-link
          >
        </template>
        <template v-if="menuIndex === 3">
          <router-link
            :to="
              i.category === 1
                ? '/about'
                : i.category === 6
                ? '/news'
                : i.category === 5
                ? '/quality'
                : i.category === 3
                ? '/history'
                : i.category === 4
                ? '/certificates'
                : '/index'
            "
            v-for="i in aboutList.aboutList"
            :key="i['name']"
            >{{ i["name"] }}</router-link
          >
        </template>
      </div>
      <div class="right">
        <div class="img_wrap">
          <template v-if="menuIndex === 1">
            <img :src="productList.image" class="menu_right_img" />
            <!-- <div class="menu_right_txt">品质为本，服务第一，用户至上</div> -->
          </template>
          <template v-if="menuIndex === 2">
            <img :src="solutionList.image" class="menu_right_img" />
            <!-- <div class="menu_right_txt">品质为本，服务第一，用户至上</div> -->
          </template>
          <template v-if="menuIndex === 3">
            <img :src="aboutList.image" class="menu_right_img" />
            <!-- <div class="menu_right_txt">品质为本，服务第一，用户至上</div> -->
          </template>
        </div>
        <!-- <img src="@/assets/images/logo_bottom.png" class="menu_right_logo" /> -->
      </div>
    </div>
    <!-- 移动端菜单栏 -->
    <div class="mobile_menu">
      <router-link to="/index">
        <img
          src="@/assets/images/logo_black.png"
          alt="sailuk"
          class="logo_mobile"
        />
      </router-link>
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <img
          src="@/assets/images/icon_menu.png"
          class="menu_mobile"
          @click="open_menu"
        />
      </transition>
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="mobile_sub_menu" v-show="mobile_menu_open">
          <!-- 一级菜单 -->
          <div class="top_menu" v-show="showTopMenu && menuIndex === 0">
            <img
              src="@/assets/images/icon_close_white.png"
              class="top_menu_close"
              @click="close_menu"
            />
            <router-link to="/index">{{ $t("menu.back_home") }}</router-link>
            <span @click="changeHoverIndex(1)">{{ $t("menu.product") }}+</span>
            <span @click="changeHoverIndex(2)">{{ $t("menu.solution") }}</span>
            <router-link to="/about">{{ $t("menu.about") }}</router-link>
            <router-link to="/contact">{{ $t("menu.contact") }}</router-link>
            <img
              src="@/assets/images/icon_search_white.png"
              alt="站内搜索"
              class="icon_search"
              @click="showSearchWrap"
            />
            <div class="lang_switch">
              <span
                :class="locale == 'zh-cn' ? 'active' : ''"
                @click="switch_chinese"
                >中文</span
              >
              <span
                :class="locale == 'en-us' ? 'active' : ''"
                @click="switch_english"
                >ENG</span
              >
            </div>
          </div>
          <!-- 二级菜单 -->
          <div class="sub_menu" v-show="showSubMenu">
            <img
              src="@/assets/images/icon_close_white.png"
              class="top_menu_close"
              @click="close_menu"
            />
            <span @click="backTopMenu">{{ $t("menu.back") }}</span>
            <router-link
              :to="'/product/' + i['pcId']"
              v-for="i in productList.categoryList"
              :key="i['name']"
              v-show="menuIndex === 1"
              @click.native=""
              >{{ i["name"] }}</router-link
            >
            <router-link
              :to="'/solution/' + i['category']"
              :key="i['category']"
              v-for="i in solutionList.solutionList"
              v-show="menuIndex === 2"
              @click.native="goZero"
              >{{ i["name"] }}</router-link
            >
            <router-link
              :to="
                i.category === 1
                  ? '/about'
                  : i.category === 6
                  ? '/news'
                  : i.category === 5
                  ? '/quality'
                  : i.category === 3
                  ? '/history'
                  : i.category === 4
                  ? '/certificates'
                  : '/index'
              "
              v-for="i in aboutList.aboutList"
              :key="i['name']"
              v-show="menuIndex === 3"
              @click.native="goZero"
              >{{ i["name"] }}</router-link
            >
          </div>
          <!-- 搜索框 遮罩层 -->
          <div class="search_menu" v-show="showSearchMenu">
            <img
              src="@/assets/images/icon_close_white.png"
              class="top_menu_close"
              @click="close_search_menu"
            />
            <div class="input_item">
              <input
                type="text"
                v-model="keyword"
                :placeholder="$t('menu.search')"
              />
              <img
                class="search-icon"
                src="@/assets/images/icon_search_white.png"
                @click="handleSearch"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </u-animate-container>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  data() {
    return {
      rootFontSize: "",
      keyword: "",
      isHover: false,
      menuIndex: 0,
      mobile_menu_open: false,
      aboutList: [],
      productList: [],
      solutionList: [],
      showSearchMenu: false,
      showSubMenu: false,
      showTopMenu: true
    };
  },
  methods: {
    switch_english() {
      this.$i18n.locale = "en-us";
      this.locale = "en-us";
      window.localStorage.setItem("lang", "en-us");
      window.location.reload();
      // window.location.href="http://www.sailuk-rivets.com/"
    },
    switch_chinese() {
      this.$i18n.locale = "zh-cn";
      this.locale = "zh-cn";
      window.localStorage.setItem("lang", "zh-cn");
      window.location.reload();
    },
    backTopMenu() {
      this.showSubMenu = false;
      this.showTopMenu = true;
      this.menuIndex = 0;
    },
    getMenu(lang) {
      let lang2 = lang ? lang : "zh-cn";
      this.$axios
        .post(
          "/api/home/menu",
          {},
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          // console.log('菜单栏')
          // console.log(res)
          this.aboutList = res.data.data.about;
          this.productList = res.data.data.product;
          this.solutionList = res.data.data.solution;
        });
    },
    hoverOn() {
      // console.log(this.isHover)
      this.isHover = true;
    },
    hoverOff() {
      // console.log(this.isHover)
      this.isHover = false;
      this.menuIndex = 0;
    },
    changeHoverIndex(e) {
      // console.log(e)
      this.showTopMenu = false;
      this.showSubMenu = true;
      this.menuIndex = e;
    },
    open_menu(e) {
      this.mobile_menu_open = true;
      this.showTopMenu = true;
      this.menuIndex = 0;
    },
    close_menu(e) {
      this.mobile_menu_open = false;
      this.showTopMenu = false;
      this.showSubMenu = false;
      this.showSearchMenu = false;
    },
    showSearchWrap(e) {
      this.showSearchMenu = true;
      this.showTopMenu = false;
      this.showSubMenu = false;
    },
    close_search_menu(e) {
      this.showSearchMenu = false;
      this.showTopMenu = true;
    },
    handleSearch() {
      let lang2 = this.locale ? this.locale : "zh-cn";
      this.$axios
        .post(
          "/api/product/search",
          {
            keyword: this.keyword
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          if (res.data.errorMsg === "SUCCESS") {
            this.$router.push({
              path:
                "/pd/" +
                res.data.data.productId +
                "/" +
                encodeURI(res.data.data.name.replace("/", ""))
            });
          } else {
            this.$alert(lang2 === "zh-cn" ? "未找到相关产品" : "No Result");
          }
        });
    },
    goZero() {
      this.menuIndex = 0;
    }
  },
  watch: {
    locale(a, b) {
      this.getMenu(a);
    }
  },
  props: {
    locale: {
      type: String,
      default: "zh-cn"
    }
  },
  created() {
    this.locale = window.localStorage.getItem("lang");
    this.getMenu(this.locale);
  }
};
</script>

<style scoped lang="scss">
#nav {
  text-align: center;
  position: fixed;
  width: 100%;
  top: 30px;
  left: 0;
  z-index: 999;
  transition: all 0.5s;
  background: #fff !important;
  height: 100px;
  .search-icon {
    cursor: pointer;
  }
  .container {
    display: inline-block;
    position: relative;
    a,
    p {
      color: #333;
      font-size: 16px;
      text-decoration: none;
      display: block;
      float: left;
      width: 180px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      position: relative;
      transition: all 0.4s;
      &:hover {
        &::after {
          width: 80px;
        }
      }
      &::after {
        position: absolute;
        content: "";
        width: 0px;
        bottom: 20px;
        height: 2px;
        background: #fe8403;
        left: 0;
        right: 0;
        margin: auto;
        transition: all 0.35s;
      }
      &.active {
        &::after {
          width: 100px;
        }
      }
      &:nth-of-type(3)::after {
        background: none;
      }
      img {
        width: 150px;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
    div.search {
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.2rem;
      text-decoration: none;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 0.8rem;
      line-height: 0.8rem;
      position: absolute;
      top: 0px;
      bottom: 0px;
      margin: auto;
      right: -150px;
      transition: all 0.4s;
      input {
        width: 200px;
        height: 30px;
        color: #fff;
        background: none;
        border: 0;
        border-bottom: 1px solid #fff;
        line-height: 30px;
        outline: 0;
        &.active {
          border-color: #333;
          border-bottom: 1px solid #333;
          color: #333;
        }
      }
      img {
        width: 18px;
        position: absolute;
        top: 23px;
        right: 0px;
      }
    }
  }
  &.hover {
    background: #fff;
    a {
      color: #333;
    }
  }
  .menu {
    position: absolute;
    top: 100px;
    left: 0;
    right: 0;
    margin: auto;
    border-top: 0px solid #fd8204;
    box-shadow: 0px 1px 10px 3px rgba(255, 255, 255, 0.4);
    width: 1140px;
    background: #fff;
    height: 0px;
    transition: all 0.5s;
    opacity: 0;
    display: none;
    .left {
      float: left;
      box-sizing: border-box;
      width: 625px;
      padding: 20px 0 20px 30px;
      overflow-y: auto;
      height: 260px;
      a {
        color: #333;
        float: left;
        width: 175px;
        height: 25px;
        margin-bottom: 10px;
        font-size: 0.16rem;
        text-align: left;
        text-decoration: none;
        line-height: 1.4;
        margin-right: 15px;
        word-wrap: break-word;
        word-break: normal;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        &:hover {
          font-weight: bold;
        }
      }
    }
    .right {
      float: right;
      position: relative;
      width: calc(1140px - 625px);
      .img_wrap {
        width: 545px;
        height: 0;
        .menu_right_img {
          width: 100%;
          height: 0;
          object-fit: cover;
        }
        .menu_right_txt {
          color: #fff;
          position: absolute;
          font-size: 0.14rem;
          top: 0;
          bottom: 0;
          right: 10px;
          margin: auto;
        }
      }
      .menu_right_logo {
        position: absolute;
        right: 15px;
        bottom: 10px;
        width: 100px;
        height: auto;
      }
    }
    &.on {
      border-top: 2px solid #fd8204;
      height: 260px;
      overflow: hidden;
      opacity: 1;
      display: block;
      .right {
        .img_wrap {
          height: 260px;
          .menu_right_img {
            height: auto;
          }
        }
      }
    }
  }
  .mobile_menu {
    display: none;
  }
}
@media screen and (max-width: 750px) {
  #nav {
    top: 0;
    height: 60px;
    z-index: 999;
    .container,
    .menu {
      display: none;
      &.on {
        display: none;
      }
    }
    .mobile_menu {
      display: flex;
      flex-direction: row;
      padding: 0 15px;
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      height: 60px;
      align-items: center;
      box-sizing: border-box;
      transition: all 0.35s;
      border-bottom: 1px solid #ddd;
      justify-content: space-between;
      background: #fff;
      img.logo_mobile {
        height: 30px;
        width: auto;
      }
      img.menu_mobile {
        cursor: pointer;
        width: 40px;
        height: 40px;
        user-select: none;
        outline: none;
        -webkit-tap-highlight-color: transparent;
        z-index: 99;
      }
      .mobile_sub_menu {
        position: fixed;
        top: 0px;
        left: 0;
        background: rgba(253, 128, 0, 0.9);
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        transition: all 0.35s;
        display: flex;
        align-content: center;
        font-size: 1rem;
        flex-direction: column;
        z-index: 999;
        img.top_menu_close {
          position: fixed;
          top: 10px;
          right: 15px;
          cursor: pointer;
          width: 40px;
          height: 40px;
          user-select: none;
          outline: none;
          -webkit-tap-highlight-color: transparent;
          z-index: 99;
        }
        .top_menu,
        .sub_menu {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          padding-top: 25%;
          a,
          span {
            text-decoration: none;
            float: left;
            width: 100%;
            color: #fff;
            margin-bottom: 1.8rem;
            font-size: 1rem;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .lang_switch {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            color: #fff;
            width: 100px;
            height: 40px;
            position: absolute;
            bottom: 20%;
            left: 0;
            right: 0;
            margin: auto;
            span {
              padding-bottom: 5px;
              font-size: 0.8rem;
              display: flex;
              height: 20px;
              justify-content: center;
              cursor: pointer;
              &.active {
                border-bottom: 1px solid #fff;
              }
            }
          }
          img.icon_search {
            display: flex;
            width: 25px;
            height: 25px;
          }
        }
        .search_menu {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #333;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          .input_item {
            display: flex;
            border-bottom: 1px solid #fff;
            width: 75%;
            height: 1.7rem;
            align-items: center;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 0 10px 0.5rem;
            input {
              display: flex;
              outline: none;
              background: none;
              border: 0;
              color: #fff;
              font-size: 1rem;
              height: 1.5rem;
              align-items: center;
            }
            img {
              width: 20px;
              height: 20px;
              display: flex;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Common/OtherNav.vue